/**
 * Query key factory for subscriptions
 * 
 * Creates a structured and typed set of keys for React Query
 * to properly handle caching and invalidation
 */
export const subscriptionKeys = {
  all: ['subscription'] as const,
  
  // Current user subscription
  user: () => [...subscriptionKeys.all, 'user'] as const,
  
  // Subscription prices available
  prices: () => [...subscriptionKeys.all, 'prices'] as const,
  
  // Customer subscription details
  customer: (userId: string) => [...subscriptionKeys.user(), { userId }] as const,
};